var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalsLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "300 175 600 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    x1: 576.24,
    y1: 245.88,
    x2: 591.84,
    y2: 245.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8309fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e863f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-2",
    x1: 395.19,
    y1: 251.76,
    x2: 484.93,
    y2: 251.76,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-3",
    x1: 394.86,
    y1: 289.39,
    x2: 484.52,
    y2: 289.39,
    xlinkHref: "#Gradiente_sem_nome_3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M522.39,287.13c4.9,6.9,12.3,9.9,17.8,9.9,7.7,0,10.3-2.8,10.3-5.8,0-3.6-2.7-4.7-12.3-8.4l-8.9-3.4c-10.8-4.1-16.2-9.8-16.2-20.3,0-12.8,11.5-21.5,27.3-21.5,12.5,0,21.6,5.1,28.3,13.1l-12.6,10.7c-6.3-7.3-11.9-9.5-18.4-9.5-4.4,0-7.3,2.1-7.3,5.3s1.5,5.1,8.5,7.5l10.1,3.5c13,4.5,19.2,10.4,19.2,21,0,12.8-10.1,22.5-28.4,22.5-11.3,0-23.2-4.7-30.4-13.3l13-11.3Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.19,252.43v-13.1h15.6v13.1h-15.6ZM591.79,309.93h-15.5v-50.4h15.5v50.4Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.59,308.83c-12.4,0-20.5-9.2-20.5-25s8.4-25.3,21-25.3c7.1,0,11.8,2.8,14.2,7v-6h15.3v45.2c0,19.8-8.6,25.9-25.6,26-13.1,0-21.8-5.2-23.9-16.3l16.3-2.4c.8,4.4,3.6,6.4,7.7,6.4,6.7,0,9.4-3.7,9.4-10.5v-4.1c-3.4,3.3-7.9,5-13.9,5ZM626.19,271.23c-6.2,0-10,4.5-10,12.7,0,8.6,3.7,12.9,9.5,12.9s9.5-3.2,9.5-12.4c0-8.5-3.3-13.2-9-13.2Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.69,309.93v-27.8c0-3.7-.5-6.2-1.7-7.8-1.1-1.4-2.8-2-5.2-2-3.1,0-5.8,1.7-7.1,3.8-1.5,2.4-2,4.7-2,9.3v24.5h-15.5v-50.4h15.2v7c3.8-4.8,9.4-8,16.4-8,5.5,0,9.5,1.6,12.1,5.1,2.2,3,3.2,7.3,3.2,13.8v32.5h-15.4Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.39,310.93c-9.7,0-15.7-5.9-15.7-15.3,0-6.1,3-10.6,9-13.5,5.4-2.5,15.9-3.7,22.5-4.1v-2.6c0-3.5-2.3-5.6-7.3-5.6-4.7,0-6.7,2.9-7.2,6.9l-14.6-1c.9-11.3,9-17.8,23.2-17.8,7.4,0,12.3,1.6,16.1,4.9,3.5,3,4.6,7.2,4.6,15.3v16.7c0,6.9.2,12.5,1.3,15.1h-14.9c-.4-1.9-.8-3.9-.8-5.8-4.2,4.7-9.2,6.8-16.2,6.8ZM747.19,287.83c-6.2.4-11.1,1.3-13.8,2.7-2.1,1.1-2.9,2.6-2.9,4.5s1.2,4.6,6,4.6c6.6,0,10.7-4.1,10.7-9.8v-2Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.99,309.93h-15.5v-70.6h15.5v70.6Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.19,293.53c3.2,4,7.9,6.3,12.6,6.3,4,0,5.4-1.7,5.4-3.4,0-2.1-1.3-3.4-8.1-5.5l-5.3-1.6c-7.4-2.2-12.8-6.6-12.8-15s7-16.4,20.8-16.4c8,0,15.6,2.9,20.9,8.6l-10.1,8.5c-3.5-3.8-7.4-5.7-11.1-5.7-3.4,0-4.9,1.2-4.9,3.2s1,3,6.6,4.8l5.9,1.8c9.4,3,13.5,7.8,13.5,15.3,0,9.7-8.2,17-21.9,17-9.1,0-16.8-3.6-22.3-9.3l10.8-8.6Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.24,
    y: 239.33,
    width: 15.6,
    height: 13.1,
    style: {
      fill: "url(#Gradiente_sem_nome_3)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.93,224.45c-4.25,3.96-8.61,7.82-12.73,11.91-12.2,12.1-24.28,24.31-36.45,36.44-12.2,12.17-30.33,9.33-38.3-5.95-4.18-8.02-2.48-18.62,4.52-26.11,5.16-5.52,10.58-10.8,15.99-16.09.84-.82,2.23-1.52,3.37-1.52,20.55-.09,63.34.93,63.6,1.31Z",
    style: {
      fill: "url(#Gradiente_sem_nome_3-2)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,317.67c3.21-3.3,5.85-6.08,8.56-8.8,13.65-13.69,27.38-27.31,40.97-41.07,8.61-8.72,21.87-9.59,31.77-1.28,7.68,6.45,11.83,18.6,4.64,29.58-1.92,2.94-4.5,5.48-6.95,8.05-3.88,4.07-7.8,8.1-11.92,11.93-1.14,1.06-2.99,1.89-4.53,1.9-19.91.13-60.97-.08-62.54-.32Z",
    style: {
      fill: "url(#Gradiente_sem_nome_3-3)",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalsLogoBlue);
export default __webpack_public_path__ + "static/media/signals-logo-blue.0ba92197c774a8a863d7c9e417ebe35a.svg";
export { ForwardRef as ReactComponent };